import axios from 'axios';

export const createCustomerPortalSession = () => axios.post('/stripe/customer_portal_session');

export default createCustomerPortalSession;
